import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { Button } from '@components/inputs/Button'
import LoadingSpinner from '@components/base/LoadingSpinner'
import { GET_EVENT_PORTAL_BY_ID } from '@graphql/events/GetEventPortalById'
import { GET_EVENT_BY_ID_FOR_UNREGISTERED_USER } from '@graphql/events/GetEventByIdForUnregisteredUser'
import moment from 'moment'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import AnnouncementIcon from '@public/images/AnnouncementIcon.svg'
import DefaultThumbnail from '@public/images/default-thumbnail.png'
import { MdEdit, MdOndemandVideo } from 'react-icons/md'
import {
  FaDonate,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaStar,
  FaTwitter,
} from 'react-icons/fa'
import { FaRegCalendarCheck } from 'react-icons/fa'
import { SessionList } from '@components/event/SessionList'
import { AttendeeList } from '@components/event/AttendeeList'
import AttendeeBox from '@components/event/AttendeeBox'

import {
  Event,
  EventSession,
  EventAttendee,
  EventType,
  FormInputType,
  EventAttendeeInput,
} from '@graphql/__generated/graphql'
import Link from 'next/link'
import { UnauthenticatedWrapperNoDefaults } from '@layouts/Wrapper'
import { useAuth } from '@libs/Auth/useAuth'
import { useTheme } from '@libs/useTheme'
import Box from '@components/base/Box'
import TextLink from '@components/base/TextLink'
import { ME } from '@graphql/users/me'
import _, { parseInt } from 'lodash'
import { TextInput } from '@components/inputs/TextInput'
import Modal from '@components/base/Modal'
import { ADD_USER_DATA } from '@graphql/users/updateEvent'
import ProfileImage from '@components/base/ProfileImage'
import EventDateTime from '@components/event/EventDateTime'
// import Card from '@components/event/Card'
// import { isValidUrl, fixUrlProtocol } from '@libs/Utility/parsers'
import SpeakerModal from '@components/event/SpeakerModal'
import useStatistics from '@libs/useStatistics'
import {
  cleanGqlPayload,
  getDynamicStyle,
  getSessionReplay,
  isJSON,
} from '@libs/Utility/util'
// import Tooltip from '@components/tootilp/Tooltip'
import RichTextDisplay from '@components/base/RichTextDisplay'
import Carousel from '@components/carousel/Carousel'
import { Toaster, toast } from 'react-hot-toast'
import { GET_USERS_BY_IDS } from '@graphql/users/GetUsersByIds'
import FooterUnauthenticated from '@components/page/FooterUnauthenticated'
import Head from 'next/head'
import YouTube from 'react-youtube'
import { parseHoldingVideoURL } from '@libs/Utility/parsers'
import {
  getRegistrationConfig,
  CONFIG_OPTIONS,
  getOrganisationConfig,
} from '@libs/Utility/register.util'
import { InputPicker } from '@components/inputs/InputPicker/InputPicker'
import { UPDATE_EVENT } from '@graphql/events/updateEvent'
import { GoogleAds } from '@libs/GoogleAdsManager'
// import { Metadata, ResolvingMetadata } from 'next'
import type { GetServerSideProps, GetStaticProps } from 'next'
import { motion } from 'framer-motion'
import { IconType } from 'react-icons'
import { usePaymentStatusPolling } from '@libs/Payments/usePaymentStatusPolling'
import {
  clearBuyTicketEventDetail,
  pushDataLayerEvent,
  shouldTrackBuyTicketEventDetail,
} from '@components/base/GoogleTags'

const ERROR_ROUTE = `/`

export const eventIdsMap: { [key: string]: string } = {
  'uofglasgow-global-burns': 'e4af5751-be4f-4a28-a17c-4e6fe64adf25',
  'flow-breakfast-fundraiser': '86ebb3f9-d291-4ab9-abad-535c6bcfc2a2',
  'forumm-academy-webinar': '86f62339-45b3-497f-91d0-cdf70567ccf3',
  'forumm-academy-alumni-engagement-round-table':
    'dbdacdf2-030f-4682-9788-9ece2f721359',
  'sussex-1980s-reunion': '59080128-59d6-4164-a824-0e48b01ef75f',
  'sussex-1960s-reunion': '2af2f67c-57aa-4b6a-b89e-dc46c3a1333a',
  edtechfirst: '5e35a0e5-52e7-4e47-a9c8-ae04c74c463d',
  scn: '21df52ff-ae4a-4297-b9ef-6055f7da6b0b',
  tectonic: '31fffe01-557f-4c3c-a7f3-cb1ec9772277',
  sps2026: '7f75a75d-ab8a-4b14-8acd-1b789f5bcdfa',
  infiniteintention: 'c2cba07a-a403-440c-8f0e-6f0788ad907b',
  golfbusinessclubfeb: '3e2c2b29-5f98-4be7-8740-2b466a8b022c',
  howlingatthemoon: '4676358b-ee5e-4f4c-812c-3cca9ff61bcf',
  wintersunshineball: '368417aa-3a45-47a8-a009-5a7f1c00223d',
  tectonicnightsummit26: 'e9b5be85-1f71-409b-8b4b-67d3700853f6',
  'scotlands-flood-resilience-conference-2027':
    '2639d8a7-33b6-4d97-9b39-2f5740399651',
}

export type EventMetadata = {
  title: string
  description: string
  image: string
  url: string
}

const getSocialIcon = (platform: string) => {
  if (platform.toLowerCase() === 'facebook')
    return <FaFacebook className="h-8 w-8 my-1 mr-2 cursor-pointer" />
  if (platform.toLowerCase() === 'twitter')
    return <FaTwitter className="h-8 w-8 my-1 mr-2 cursor-pointer" />
  if (platform.toLowerCase() === 'instagram')
    return <FaInstagram className="h-8 w-8 my-1 mr-2 cursor-pointer" />
  if (platform.toLowerCase() === 'linkedin')
    return <FaLinkedin className="h-8 w-8 my-1 mr-2 cursor-pointer" />

  return <FaFacebook className="h-8 w-8 my-1 mr-2 cursor-pointer" />
}

export default function EventPage({ metadata }: any) {
  const router = useRouter()
  const paymentQuery = Array.isArray(router.query.payment)
    ? router.query.payment[0]
    : router.query.payment
  const paymentOrderId = Array.isArray(router.query.orderId)
    ? router.query.orderId[0]
    : router.query.orderId
  const { state: paymentState } = usePaymentStatusPolling(
    paymentOrderId,
    paymentQuery === 'processing'
  )
  const [updateEvent] = useMutation(UPDATE_EVENT)
  const _statisticId = useStatistics()
  const {
    profile,
    isLogged,
    isOrganizer,
    isAdmin,
    canEditEvent,
    getPermission,
  } = useAuth()
  const { data: me } = useQuery(ME)
  const membershipAccess = getPermission('USER::MEMBERSHIP::*')

  const { setTheme, theme, StaticColours, refreshTheme } = useTheme()
  const [addUserData] = useMutation(ADD_USER_DATA)
  const [showFieldModal, setShowFieldModal] = useState(false)
  const [eventHasTicketsAvailable, setEventHasTicketsAvailable] =
    useState<boolean>(true)
  const [requiredInfo, setRequiredInfo] = useState<string[]>([])
  const [eventAttendees, setEventAttendees] = useState<EventAttendee[]>([])
  const [fieldVals, setFieldVals] = useState<any>()
  const [speakerModalTarget, setSpeakerModalTarget] = useState<any>(undefined)
  const [shareButtonText, setShareButtonText] = useState<string>('Share')
  const dynamicStyle = getDynamicStyle(theme.highlightColour)
  const [event, setEvent] = useState<Partial<Event> | undefined>(undefined)
  const [userRegistrationFields, setUserRegistrationFields] = useState<any[]>(
    []
  )
  const [registrationError, setRegistrationError] = useState<
    Record<string, string | undefined>
  >({})

  useEffect(() => {
    if (paymentQuery !== 'processing') return
    if (paymentState === 'processing') {
      toast.loading('Confirming your bank payment...', {
        id: 'payment-status',
      })
      return
    }
    if (paymentState === 'confirmed') {
      toast.success('Payment confirmed. Your tickets are ready!', {
        id: 'payment-status',
        duration: 10000,
      })
      return
    }
    if (paymentState === 'failed') {
      toast.error('Payment failed. Your tickets were not confirmed.', {
        id: 'payment-status',
        duration: 10000,
      })
      return
    }
    if (paymentState === 'timed_out') {
      toast(
        'Payment is still processing. Check your email before trying again.',
        { id: 'payment-status', duration: 10000 }
      )
    }
  }, [paymentQuery, paymentState])

  const pageUrl = `https://app.${process.env.NEXT_PUBLIC_DOMAIN as string}${
    router.asPath
  }`

  let mediaType = 'VIDEO'
  let videoUrl =
    'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/video-background.mp4'

  if (event?.eventId === 'c2cba07a-a403-440c-8f0e-6f0788ad907b')
    videoUrl =
      'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Infinite+Intentions+Video+(1).mp4'

  if (event?.eventId === 'c987cfd9-3732-4d21-a586-293ed6d36784')
    videoUrl =
      'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/video-background_CE.mp4'

  // Sussex BSMS Hardship Grants
  if (event?.eventId === 'cd54965b-4538-44bf-b177-1f0837706cee') {
    videoUrl =
      'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Sussex+Banner+Option.png'
    mediaType = 'IMG'
  }

  if (event?.eventId === 'e172670e-a062-4f05-9e33-b334a57fff93') {
    videoUrl =
      'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Forumm+Header.jpg'
    mediaType = 'IMG'
  }

  if (event?.eventId === '236e01cf-bcfb-41e0-94e9-4c173e2e16f4') {
    videoUrl =
      'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/pawel-czerwinski-W_mfoOi1Elc-unsplash.jpg'
    mediaType = 'IMG'
  }

  if (event?.eventId === 'acc6d01b-d339-4dfc-9df3-8ccef3ec7594') {
    videoUrl =
      'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/The+Scottish+Marketing+Network+Highlight+Reel.mp4'
  }

  if (
    event?.eventId === 'deef2f23-a324-42bb-8cac-e632e135faee' ||
    event?.eventId === '795fdc4b-10fa-4f16-8be6-7046e1b3a6bc'
  ) {
    videoUrl =
      'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Hampden+Park+Banner.jpg'
    mediaType = 'IMG'
  }
  if (event?.eventId === '91947a10-235c-4e1e-94bd-442257efec8d') {
    videoUrl =
      'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Celtic+Park+Background.png'
    mediaType = 'IMG'
  }

  if (event?.eventId === 'e9b5be85-1f71-409b-8b4b-67d3700853f6')
    videoUrl =
      'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Forumm+Highlight+Video-1.m4v'

  if (event?.eventId === '1fce6cb9-b5c3-45f5-ab48-f453a22215a3')
    videoUrl =
      'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/Anmara.mp4'

  const [getEventForUnregisteredUser] = useLazyQuery(
    GET_EVENT_BY_ID_FOR_UNREGISTERED_USER
  )

  const userData = router.query.ud

  const [ctaLabel, setCtaLabel] = useState<{
    label: string
    icon?: JSX.Element
    enabled: boolean
    action: () => void
    show: boolean
  }>()

  const getCtaLabel = () => {
    const currentDate = new Date(Date.now()).valueOf()

    const endDate = moment(event?.event?.endDateTime).toDate().valueOf()
    const entryTime = moment(event?.event?.entryDateTime).toDate().valueOf()
    const endDatePlus15Minutes = new Date(endDate + 15 * 60 * 1000).valueOf()

    const hasMembership = membershipAccess.includes(
      event?.event?.organizationName ?? '*'
    )

    let hasTicket = getTicketStatus()
    let label = hasTicket ? 'Enter Event Hub' : 'Register for Event'
    let enabled = true
    let show = true
    let icon = (
      <FaRegCalendarCheck
        style={{ fill: '#fff', marginLeft: '5px' }}
        fontSize="1em"
      />
    )

    const canViewEarly = ((): boolean => {
      const eventOrgName = event?.event?.organizationName
      if (isAdmin) return true
      if (isOrganizer) {
        if (eventOrgName === profile?.university) return true
        if (eventOrgName === profile?.company) return true
      }
      if (
        event?.speakers?.find(
          (s) => s.email?.toLowerCase() === profile?.email?.toLowerCase()
        )
      )
        return true
      return false
    })()

    const requiredFieldNames =
      event?.registrationFields?.map((f) => f.name) ?? []

    //Participants with tickets should not be able to join the event until it has started
    if (hasTicket && currentDate < entryTime && !canViewEarly) {
      enabled = false
    }

    let action = () => {
      if (hasTicket && me) {
        const myFields = me.me.registrationFields ?? {}

        const myFieldNames: string[] = []

        Object.keys(myFields).forEach((key) => {
          Object.keys(myFields[key]).forEach((k) => {
            myFieldNames.push(k)
          })
        })

        const attendeeData = event?.attendees?.find(
          (a) => a.email === profile?.email || a.userId === profile?.userId
        )

        const missingFieldNames = _.difference(requiredFieldNames, myFieldNames)

        if (
          missingFieldNames.length > 0 &&
          // !isAdmin &&
          attendeeData?.requireRegistrationFields !== false
        ) {
          setRequiredInfo(missingFieldNames)
          setShowFieldModal(true)
        } else {
          router.push(`/event/${event?.eventId}/agenda`)
        }
      } else {
        if (event?.isPremium && !hasMembership) {
          router.push(`/membership/${event?.event?.organizationName}`)
        } else {
          if (userData)
            router.push(`/event/${event?.eventId}/register?ud=${userData}`)
          router.push(`/event/${event?.eventId}/register`)
        }
      }
    }

    if (currentDate < entryTime && hasTicket && !canViewEarly) {
      label = 'Event not started'
      enabled = false
    } else if (currentDate > endDatePlus15Minutes) {
      label = 'Event ended'
      enabled = false
    }
    if (!hasTicket && !eventHasTicketsAvailable) {
      label = 'Sold Out'
      enabled = false
    }
    if (!hasTicket && !canRegister) {
      label = 'Registration Closed'
      enabled = false
    }

    if (event?.event?.eventType === EventType.InPerson && hasTicket) {
      label = 'Registered'
      enabled = false
    }
    if (
      hasTicket &&
      currentDate > entryTime &&
      currentDate < endDatePlus15Minutes
    ) {
      enabled = true
    }
    if (
      !hasTicket &&
      !hasMembership &&
      event?.isPremium &&
      currentDate < endDatePlus15Minutes
    ) {
      label = 'Membership Required'
      enabled = true
      icon = <FaStar className="ml-2" fill={'white'} />
    }

    const payload = {
      label,
      enabled,
      action,
      show,
      icon,
    }

    console.log({ CTA: payload })
    setCtaLabel(payload)
    return payload
  }

  const eventId = (() => {
    const eventIdQuery = router.query.eventId as string

    if (eventIdQuery) {
      const decodedEventId = decodeURIComponent(eventIdQuery)
        .trim()
        .toLowerCase()

      if (eventIdsMap[eventIdQuery]) return eventIdsMap[eventIdQuery]
      if (eventIdsMap[decodedEventId]) return eventIdsMap[decodedEventId]
    }
    return eventIdQuery
  })()

  const canGetPortal = isOrganizer || isAdmin || !!profile

  const shouldSkipQuery = !router.query.eventId || !canGetPortal

  const { loading, error, data, refetch, startPolling, stopPolling } = useQuery(
    GET_EVENT_PORTAL_BY_ID,
    {
      variables: {
        input: {
          eventId: eventId as string,
        },
      },
      skip: shouldSkipQuery,
      fetchPolicy: 'network-only',
      onCompleted: getCtaLabel,
    }
  )

  useEffect(() => {
    if (shouldSkipQuery) return

    startPolling(2000)
    const pollingTimeout = setTimeout(stopPolling, 10000)

    return () => {
      clearTimeout(pollingTimeout)
      stopPolling()
    }
  }, [eventId, shouldSkipQuery, startPolling, stopPolling])

  useEffect(() => {
    if (event) {
      const cachedEvent = { ...event, stages: [], breakoutRooms: [] }
      const latestEvent = {
        ...data?.getEventById,
        stages: [],
        breakoutRooms: [],
      }
      const eventChaged =
        JSON.stringify(cachedEvent) !== JSON.stringify(latestEvent)
      if (!eventChaged) return
    }
    if (!!data?.getEventById) {
      setTheme({
        ...theme,
        organisationName: data.getEventById.event?.organizationName,
      })
      return setEvent(data.getEventById as Event)
    }
    if (eventId && !loading && !data && !profile) {
      getEventForUnregisteredUser({
        variables: {
          input: {
            eventId: eventId as string,
            userEmail: encodeURIComponent(userData as string),
          },
        },
      }).then((d) => {
        if (d.data?.getEventByIdForUnregisteredUser) {
          setTheme({
            ...theme,
            organisationName:
              d.data.getEventByIdForUnregisteredUser.event?.organizationName,
          })
          setEvent(d.data?.getEventByIdForUnregisteredUser as Event)
        }

        if (d.error) {
          console.error(d.error)
          router.push(ERROR_ROUTE)
        }
      })
    }
  }, [loading, data, userData, eventId])

  const canRegister = moment(event?.event?.registrationCloseDateTime).isAfter(
    moment()
  )

  const canViewOrganizerInfo = useMemo(() => {
    return isAdmin || (isOrganizer && canEditEvent(event as Event))
  }, [event, isOrganizer, isAdmin])

  const trackedEventDetailIdRef = useRef<string>()
  useEffect(() => {
    const loadedEventId = event?.eventId
    if (
      !router.isReady ||
      !loadedEventId ||
      canViewOrganizerInfo ||
      Object.prototype.hasOwnProperty.call(router.query, 'registered') ||
      trackedEventDetailIdRef.current === loadedEventId ||
      !shouldTrackBuyTicketEventDetail(loadedEventId)
    )
      return

    pushDataLayerEvent('buy_ticket_event_detail')
    trackedEventDetailIdRef.current = loadedEventId
  }, [
    canViewOrganizerInfo,
    event?.eventId,
    router.isReady,
    router.query.registered,
  ])

  const attendeeBox = useMemo(() => {
    if (
      // !canViewOrganizerInfo &&
      !!event &&
      !!event.attendees &&
      !!event.registrationFields &&
      !!event.event?.organizationName
    )
      return (
        <AttendeeBox
          show={
            event?.event?.showAttendeeBox ||
            getRegistrationConfig(CONFIG_OPTIONS.SHOW_ATTENDEE_BOX, event!)
          }
          eventId={eventId}
          event={{
            attendees: event.attendees,
            registrationFields: event.registrationFields,
            organisationName: event.event?.organizationName,
          }}
        />
      )
  }, [isAdmin, isOrganizer, data, event])

  const getTicketStatus = () => {
    if (isAdmin) return true

    if (
      isOrganizer &&
      (profile?.company === event?.event?.organizationName ||
        profile?.university === event?.event?.organizationName)
    )
      return true

    const userHasTicket = [
      ...(event?.attendees?.map((a) => a.email?.toLowerCase()) ?? []),
      ...(event?.speakers?.map((s) => s.email?.toLowerCase()) ?? []),
      event?.organizerId,
    ].some((id) => {
      if (!id) return false
      return (
        id === profile?.email?.toLowerCase() ||
        id === profile?.userId?.toLowerCase()
      )
    })

    return userHasTicket
  }

  useEffect(() => {
    if (event && event?.eventId) {
      getCtaLabel()
    }
  }, [event, profile])

  const trackedRegistrationCompleteIdRef = useRef<string>()
  useEffect(() => {
    const loadedEventId = event?.eventId
    if (!router.isReady || !loadedEventId) return
    if (!Object.prototype.hasOwnProperty.call(router.query, 'registered'))
      return
    if (trackedRegistrationCompleteIdRef.current === loadedEventId) return

    pushDataLayerEvent('buy_ticket_registration_complete')
    trackedRegistrationCompleteIdRef.current = loadedEventId
    clearBuyTicketEventDetail(loadedEventId)

    const currentUrl = new URL(window.location.href)
    currentUrl.searchParams.delete('registered')
    window.history.replaceState(
      window.history.state,
      '',
      `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
    )

    toast(`Successfully registered for the event!`, {
      icon: '🎉',
      duration: 10000,
    })
  }, [event?.eventId, router.isReady, router.query.registered])

  useEffect(() => {
    if (!event && !data && error && !loading && !shouldSkipQuery) {
      if (!isLogged && !userData) router.push(ERROR_ROUTE)
      if (isLogged && profile) router.push(ERROR_ROUTE)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, data, profile, isLogged])

  useEffect(() => {
    const getTicketsAvailable = () => {
      let totalAvailable = 0
      event?.availableTickets?.tickets?.forEach((t) => {
        if (t && t.remaining && parseInt(t.remaining) > 0)
          totalAvailable += parseInt(t.remaining)
      })

      return totalAvailable > 0
    }
    if (event) {
      refreshTheme(event as Event)
      setEventHasTicketsAvailable(getTicketsAvailable())
    }
  }, [event, refreshTheme])

  useEffect(() => {
    if (event) {
      setEventAttendees(event?.attendees || [])
    }
  }, [event])

  if (loading || !event) {
    return (
      <>
        {/* {headerMetadata} */}
        <Box className="w-full py-64 flex justify-center">
          <LoadingSpinner size="large" />
          <Toaster
            toastOptions={{
              className:
                'shadow-lg !rounded-full flex items-center border-2 !bg-forumm-white border-forumm-green !text-forumm-green mt-[80px]',
              duration: 4000,
            }}
          />
        </Box>
      </>
    )
  }

  const isDarkTheme = theme.type === 'DARK'
  const buttonDonate = isDarkTheme
    ? 'bg-forumm-light-blue-dark text-forumm-text-blue-dark'
    : 'bg-forumm-active-blue text-white'

  const eventImage =
    event?.event?.bannerImage ??
    'https://assets.tumblr.com/images/default_header/optica_pattern_11.png'

  const addFieldModal = (
    <Modal
      show={showFieldModal}
      setShow={setShowFieldModal}
      title="Add Required information"
    >
      {event?.registrationFields?.map((field) => {
        const id = `${profile?.userId}-${eventId}`
        const fieldName = `${profile?.userId}::${field.name
          .replaceAll(' ', '_')
          .toLowerCase()}`

        return (
          <Box key={id} className={`mb-8`}>
            <InputPicker
              ukey={`registration_field_input_${id}`}
              type={!!field.type ? field.type : FormInputType.Text}
              dateOnly={!!field?.dateOnly ? field.dateOnly : false}
              validations={{
                minLength: {
                  value: 1,
                  message: 'Field name must be at least 1 character',
                },
              }}
              value={fieldVals ? fieldVals[field.name] : undefined}
              onChange={(e) => {
                let payload = { ...fieldVals }

                payload = {
                  ...payload,
                  [field.name]: e,
                }

                let errorPayload: Record<string, string | undefined> =
                  registrationError
                if (errorPayload?.[fieldName])
                  errorPayload[fieldName] = undefined
                setRegistrationError(errorPayload)
                setFieldVals(payload)
              }}
              required={field.required ?? false}
              label={field.name}
              placeholder={field.name}
              options={field?.options ?? []}
              error={registrationError?.[fieldName]}
            />
          </Box>
        )
      })}
      <Button
        className="my-4"
        title={`Submit`}
        type="primary"
        buttonType="submit"
        onClick={async () => {
          const values = Object.keys(fieldVals).map((key) => ({
            name: key,
            value: fieldVals[key],
          }))
          console.log({ values })
          if (
            values.length > 0 &&
            values.filter((v) => v.value === '').length === 0
          ) {
            await addUserData({
              variables: {
                input: {
                  company: event?.event?.organizationName ?? 'Unknown',
                  values: values,
                },
              },
            })
              // Used to set requiredRegistration to false after the user completes the registration answers
              // .then(async () => {
              //   const attendees = (cleanGqlPayload(event.attendees) ??
              //     []) as EventAttendeeInput[]
              //   const payload: EventAttendeeInput = {
              //     ...(attendees?.find((a) => a.email === profile?.email) ?? []),
              //     requireRegistrationFields: false,
              //   } as EventAttendeeInput
              //
              //   if (
              //     !!event &&
              //     !!event.attendees &&
              //     payload.email === profile?.email
              //   )
              //     await updateEvent({
              //       variables: {
              //         input: {
              //           eventId: eventId as string,
              //           attendees: [...attendees, payload],
              //         },
              //       },
              //     })
              // })
              .finally(() => router.push(`/event/${event?.eventId}/agenda`))
          }
        }}
      />
    </Modal>
  )

  const getSocialLink = (platform: string, fallbackURL?: string) => {
    return (
      event?.communications?.socials?.find(
        (s) => s.platform.toLowerCase() === platform.toLowerCase()
      )?.url ??
      fallbackURL ??
      false
    )
  }

  const noAnnouncements = !event?.communications?.announcements
  const announcements = noAnnouncements
    ? []
    : event?.communications?.announcements

  const publiclyVisibleAttendes = (
    (eventAttendees as EventAttendee[]) ?? []
  ).filter((at) => at.registrationVisible)

  const visibleAttendees = canViewOrganizerInfo
    ? eventAttendees
    : publiclyVisibleAttendes

  const sessionReplay = getSessionReplay(event)
  // console.log({
  //   sessionReplay,
  //   id: sessionReplay && parseHoldingVideoURL(sessionReplay),
  // })

  return (
    <>
      {/* {headerMetadata} */}
      <Box
        className={`-mt-[80px] pt-[80px] overflow-x-hidden h-[calc(100vh)] relative`}
      >
        {addFieldModal}
        {
          <SpeakerModal
            show={!!speakerModalTarget}
            setShow={setSpeakerModalTarget}
            speaker={speakerModalTarget}
          />
        }
        {/* Background Image */}
        <Box
          color="foregroundColour"
          style={dynamicStyle as unknown as {}}
          className={`relative px-2 pt-9 pb-9 border-b border-forumm-menu-border`}
        >
          {mediaType === 'VIDEO' ? (
            <video
              autoPlay
              loop
              muted
              playsInline
              className="absolute inset-0 w-full h-full object-cover select-none no-controls"
            >
              <source src={videoUrl} type="video/mp4" />
            </video>
          ) : (
            <img
              src={videoUrl}
              alt="Background Image"
              className="absolute inset-0 w-full h-full object-cover select-none"
            />
          )}
          <Box className="flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0">
            <Box
              className={`rounded-2xl shadow-lg flex p-10 md:p-6 md:py-4 md:pt-6 md:pb-6 w-full md:w-[85%] max-w-[1500px] ${
                isDarkTheme ? '' : 'border border-forumm-menu-border'
              }`}
              color="backgroundColorBanner"
              style={{
                background: isDarkTheme
                  ? 'rgba(0, 0, 0, 0.6)'
                  : 'rgba(255, 255, 255, 0.6)',
                backdropFilter: 'blur(5px)',
                WebkitBackdropFilter: 'blur(5px)',
              }}
            >
              <Box className="flex flex-col items-center md:flex-row md:items-center">
                <Box className="flex ml-0 md:ml-3 items-center">
                  <Box className="md:h-[250px] md:w-[250px] w-[250px] h-[240px] md:rounded-2xl rounded-md overflow-hidden flex flex-col justify-start items-center mx-auto md:ml-2 mb-2 md:mb-0">
                    <Box
                      className="h-full w-full bg-cover bg-center"
                      style={{ backgroundImage: `url('${eventImage}')` }}
                    ></Box>
                  </Box>
                </Box>

                <Box className="md:w-full ml-2 md:ml-20 md:mr-10 ml-0 flex">
                  <Box>
                    <Box className="flex flex-row items-center mb-0">
                      <Image
                        alt="Thumbnail Image"
                        className="h-10 w-10 rounded-full mr-3 object-cover"
                        width={30}
                        height={30}
                        src={event?.event?.thumbnailImage ?? DefaultThumbnail}
                      />
                      <Box
                        className="flex items-center text-xs md:text-sm !text-gray-600 cursor-pointer"
                        onClick={() => {
                          router.push(
                            `/org/${event.event?.organizationName.toLowerCase().replaceAll(' ', '-')}`
                          )
                        }}
                      >
                        {/* <Tooltip id="eventTitleDescription"> */}
                        {event?.event?.organizationName}
                        {/* </Tooltip> */}
                      </Box>
                    </Box>
                    <Box className="text-[36px] w-full font-bold">
                      {event?.event?.title}
                    </Box>
                    <Box className="mb-4" style={{ whiteSpace: 'pre-wrap' }}>
                      <TextLink className="text-xs md:text-sm mt- mb-4 !text-gray-600">
                        {event?.event?.shortDescription}
                      </TextLink>
                    </Box>

                    <Box
                      show={
                        !!event.event?.eventLocation ||
                        !!event?.event?.internalLocation
                      }
                      className=""
                    >
                      <Box className={`text-md font-bold`}>Event Location</Box>
                      <TextLink className="text-xs md:text-sm !text-gray-600">
                        {event?.event?.isInternal
                          ? event?.event?.internalLocation ||
                            event?.event?.eventLocation
                          : event?.event?.eventLocation}{' '}
                      </TextLink>
                    </Box>

                    <Box
                      show={
                        !!event?.event?.eventLocationMapLink &&
                        !!(event?.event?.eventLocationMapLink.length > 0)
                      }
                    >
                      <Link
                        href={event?.event?.eventLocationMapUrl ?? '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-xs md:text-sm text-forumm-blue underline"
                      >
                        {event?.event?.eventLocationMapLink}
                      </Link>
                    </Box>

                    {/* Event Dates */}
                    <Box className="flex mb-4 mt-4">
                      <Box className="flex flex-col space-y-2 mr-4">
                        <Box className={`text-md font-bold !-mb-1`}>
                          Start Time/Date
                        </Box>
                        <Box className="text-xs md:text-sm !text-gray-600">
                          <EventDateTime
                            value={event?.event?.startDateTime}
                            format="MMM DD, h:mmA"
                            event={event?.event}
                          />
                        </Box>
                      </Box>
                      <Box className="flex flex-col space-y-2">
                        <Box className={`text-md font-bold !-mb-1`}>
                          End Time/Date
                        </Box>
                        <Box className="text-xs md:text-sm !text-gray-600">
                          <EventDateTime
                            value={event?.event?.endDateTime}
                            format="MMM DD, h:mmA"
                            event={event?.event}
                          />
                        </Box>
                      </Box>
                    </Box>

                    <Box
                      show={
                        !!event?.communications?.socials &&
                        event?.communications?.socials?.length > 0
                      }
                      className="flex items-center justify-start text-white mt-6 flex-wrap mb-4"
                    >
                      {event?.communications?.socials?.map((s) => {
                        return (
                          <motion.div
                            whileHover={{ scale: 1 }}
                            key={s.platform}
                          >
                            <Link
                              href={s.url}
                              target={'_blank'}
                              data-testid="social-facebook"
                            >
                              {getSocialIcon(s.platform)}
                            </Link>
                          </motion.div>
                        )
                      })}
                    </Box>

                    {/* Button Register to Event y Share */}
                    <Box className="flex items-center sm:mt-0 flex-wrap justify-between lg:justify-start">
                      <Button
                        show={ctaLabel?.show}
                        title={`${ctaLabel?.label ?? 'Register to Event'}`}
                        disabled={!ctaLabel?.enabled}
                        onClick={ctaLabel?.action}
                        icon={
                          ctaLabel?.icon ?? (
                            <FaRegCalendarCheck
                              style={{ fill: '#fff', marginLeft: '5px' }}
                              fontSize="1em"
                            />
                          )
                        }
                        className={`mb-4 rounded-full min-w-48 text-[13px] mr-2 w-full md:w-auto md:max-w-xs flex items-center justify-center ${buttonDonate}`}
                      />
                      <Button
                        show={
                          ((!!event.fundraising?.title &&
                            event.fundraising.title.length > 0) ||
                            !!event.event?.donationUrl) &&
                          !!event?.fundraising?.enabled
                        }
                        className={`mb-4 rounded-full min-w-48 text-[13px] mr-2 w-full md:w-auto md:max-w-xs flex items-center justify-center ${buttonDonate}`}
                        title={`Donate`}
                        icon={
                          <FaDonate
                            style={{ fill: '#fff', marginLeft: '5px' }}
                            fontSize="1em"
                          />
                        }
                        onClick={() =>
                          router.push(`/event/${event.eventId}/donate`)
                        }
                      />
                      <Button
                        className={`mb-4 rounded-full min-w-48 text-[13px] mr-2 w-full md:w-auto md:max-w-xs flex items-center justify-center ${buttonDonate}`}
                        title={shareButtonText}
                        icon={
                          <svg
                            width="13"
                            height="16"
                            viewBox="0 0 13 16"
                            fill={'#fff'}
                            xmlns="http://www.w3.org/2000/svg"
                            className="mr-1"
                          >
                            <path d="M11.375 0.601562H4.625C3.8 0.601562 3.125 1.27656 3.125 2.10156V11.1016C3.125 11.9266 3.8 12.6016 4.625 12.6016H11.375C12.2 12.6016 12.875 11.9266 12.875 11.1016V2.10156C12.875 1.27656 12.2 0.601562 11.375 0.601562ZM11.375 11.1016H4.625V2.10156H11.375V11.1016ZM0.125 10.3516V8.85156H1.625V10.3516H0.125ZM0.125 6.22656H1.625V7.72656H0.125V6.22656ZM5.375 14.1016H6.875V15.6016H5.375V14.1016ZM0.125 12.9766V11.4766H1.625V12.9766H0.125ZM1.625 15.6016C0.8 15.6016 0.125 14.9266 0.125 14.1016H1.625V15.6016ZM4.25 15.6016H2.75V14.1016H4.25V15.6016ZM8 15.6016V14.1016H9.5C9.5 14.9266 8.825 15.6016 8 15.6016ZM1.625 3.60156V5.10156H0.125C0.125 4.27656 0.8 3.60156 1.625 3.60156Z" />
                          </svg>
                        }
                        onClick={(e) => {
                          navigator.clipboard.writeText(
                            `https://${window.location.hostname}${router.asPath}`
                          )
                          setShareButtonText('Copied!')
                          setTimeout(() => {
                            setShareButtonText('Share')
                          }, 3000)
                          e.preventDefault()
                        }}
                      />
                      <Button
                        show={isOrganizer && canEditEvent(event as Event)}
                        className={`mb-4 rounded-full min-w-48 text-[13px] mr-2 w-full md:w-auto md:max-w-xs flex items-center justify-center ${buttonDonate}`}
                        title="Edit"
                        icon={
                          <MdEdit style={{ fill: '#fff' }} fontSize="1.5em" />
                        }
                        onClick={() => {
                          router.push(`/create-event?id=${event.eventId}`)
                        }}
                      />
                    </Box>
                    {!loading && !profile && (
                      <Box className="mt-4 text-xs md:text-sm">
                        Already registered?{' '}
                        <Link
                          className="underline"
                          href={{
                            pathname: '/login',
                            query: {
                              intent: 'buy_ticket',
                              redirect: router.asPath,
                            },
                          }}
                        >
                          Log in here
                        </Link>
                        . Having trouble? Email{' '}
                        <a className="underline" href="mailto:hello@forumm.to">
                          hello@forumm.to
                        </a>
                        .
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className={`sm:px-4 w-full flex justify-center `}>
          <Box className="w-full md:w-[85%] max-w-[1500px]">
            {/* Announcements */}
            <Box className="mt-8 mb-64">
              {announcements && announcements.length > 0 && (
                <Box
                  className="p-10 rounded-xl border border-forumm-menu-border"
                  color="foregroundColour"
                >
                  <Box className="text-2xl font-medium flex space-x-2">
                    <AnnouncementIcon
                      fill={theme.textColour}
                      className="w-8 h-8"
                    />
                    <span>Announcements</span>
                  </Box>
                  {!noAnnouncements ? (
                    <Box className="mt-8">
                      {announcements?.map((a) => {
                        return (
                          <Box key={a.title}>
                            <h3 className="text-lg mt-6 font-semibold">
                              {a.title}
                            </h3>
                            {isJSON(a.body) ? (
                              <RichTextDisplay
                                key={a.title}
                                descriptionJson={a.body}
                              />
                            ) : (
                              <p className="text-xs md:text-sm">{a.body}</p>
                            )}
                          </Box>
                        )
                      })}
                    </Box>
                  ) : (
                    <Box className="mt-8 text-xs md:text-sm">
                      No Announcements
                    </Box>
                  )}
                </Box>
              )}

              <Box
                className="mt-8 p-10 rounded-xl border border-forumm-menu-border h-full"
                color="foregroundColour"
                show={!!sessionReplay}
              >
                <Box className="text-2xl font-medium flex space-x-2 mb-4">
                  <MdOndemandVideo
                    fill={theme.textColour}
                    className="w-8 h-8"
                  />
                  <span>Session Playback</span>
                </Box>
                {sessionReplay.toString().includes('manual-upload') ? (
                  <video
                    // className="h-96 w-full -mt-2 -mb-4"
                    className="mt-6 rounded w-full h-full"
                    controls
                  >
                    <source src={sessionReplay as string} type="video/mp4" />
                  </video>
                ) : (
                  <Box className="">
                    <YouTube
                      videoId={parseHoldingVideoURL(sessionReplay as string)}
                      /* iframeClassName="pointer-events-none " */
                      className="h-[70vh] mx-auto"
                      opts={{
                        height: '100%',
                        width: '100%',
                        playerVars: {
                          version: 3,
                          loop: 0,
                          // playlist: sessionReplay,
                          autoplay: 0,
                          mute: 0,
                          modestbranding: 1,
                          showinfo: 0,
                          controls: 1,
                          enablejsapi: 1,
                          rel: 0,
                        },
                      }}
                    />
                  </Box>
                )}
              </Box>

              {/*<Box className="mt-8 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full">
              <Box
                color="foregroundColour"
                className="rounded-2xl flex flex-col p-10 border border-forumm-menu-border flex-2"
              >
                <Box className="text-2xl font-medium">Program Title</Box>
                <Box className="mt-8 text-justify text-sm space-y-4 md:space-y-0">
                  <ReactMarkdown>
                    {event?.event?.shortDescription ?? ''}
                  </ReactMarkdown>
                </Box>
              </Box>
                </Box>*/}

              {/* <Box className="mt-8 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full"> */}
              {/* Description */}
              {/* <Box
                color="foregroundColour"
                className="rounded-2xl flex flex-col p-10 border border-forumm-menu-border flex-2"
              >
                <Box className="text-2xl font-medium">Description</Box>
                <Box className="mt-8 text-justify text-sm md:columns-2 columns-1 space-y-4 md:space-y-0">
                  {(window.location.href.includes('forumm-academy-webinar') ||
                    window.location.href.includes(
                      '61c0465c-9177-4ac0-8d4e-7347b58d2ad8'
                    )) && (
                    <Box>
                      <iframe
                        src="https://www.loom.com/embed/a57f9c5c676941ae950c37707242721e"
                        frameBorder="0"
                        allowFullScreen
                        style={{
                          width: '100%',
                          height: '300px',
                          border: 'none',
                        }}
                      ></iframe>
                      <Box className="h-[150px]" />
                    </Box>
                  )} */}
              {/* <ReactMarkdown> */}
              {/* {event?.event?.description ?? ''} */}
              {/* </ReactMarkdown> */}
              {/* </Box>
              </Box>
            </Box> */}
              <Box className="mt-8 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full">
                {/* Description Box */}
                <Box
                  color="foregroundColour"
                  className="rounded-2xl flex flex-col p-10 border border-forumm-menu-border flex-2"
                >
                  <Box className="text-2xl font-medium">Description</Box>
                  <Box className="my-6" style={{ whiteSpace: 'pre-wrap' }}>
                    {(window.location.href.includes('forumm-academy-webinar') ||
                      window.location.href.includes(
                        '61c0465c-9177-4ac0-8d4e-7347b58d2ad8'
                      )) && (
                      <Box>
                        <iframe
                          src="https://www.loom.com/embed/a57f9c5c676941ae950c37707242721e"
                          frameBorder="0"
                          allowFullScreen
                          style={{
                            width: '100%',
                            height: '350px',
                            border: 'none',
                          }}
                        ></iframe>
                        <Box className="h-[25px]" />
                      </Box>
                    )}

                    {/* Use RichTextDisplay to show descripción */}
                    {event?.event?.description ? (
                      <RichTextDisplay
                        descriptionJson={event.event.description}
                      />
                    ) : (
                      'No description provided.'
                    )}
                  </Box>
                </Box>
                {attendeeBox}
              </Box>

              <GoogleAds
                show={getOrganisationConfig(
                  CONFIG_OPTIONS.SHOW_GOOGLE_ADS,
                  event.event?.organizationName ??
                    profile?.company ??
                    profile?.university
                )}
                type="horizontal"
                className="mt-8"
              />

              <Box className="mt-8 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full">
                {/* Sessions */}
                <Box
                  show={!!event?.sessions && event?.sessions?.length > 0}
                  color="foregroundColour"
                  className="rounded-2xl flex flex-col p-8 border border-forumm-menu-border flex-1"
                >
                  <Box className="text-justify text-sm">
                    <SessionList
                      sessions={(event?.sessions as EventSession[]) ?? []}
                      eventId={event?.eventId!}
                      eventType={event?.event?.eventType}
                      timeZone={event?.event?.timeZone}
                      timeZoneId={event?.event?.timeZoneId}
                    />
                  </Box>
                </Box>
              </Box>
              <Box className="mt-2 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full mt-9">
                <Box
                  show={!!event?.speakers && event?.speakers?.length > 0}
                  color="foregroundColour"
                  className="rounded-2xl flex flex-col p-8 border border-forumm-menu-border flex-2"
                >
                  <Box className="text-2xl font-medium">Speakers</Box>
                  <Box className="text-justify text-sm">
                    {/* Redudant code, this wont be loaded if there are no speakers. */}
                    {/* {(!event?.speakers || event?.speakers?.length === 0) && ( */}
                    {/*   <Box className="my-8"> */}
                    {/*     No speakers have been added for this event yet. Check back */}
                    {/*     soon! */}
                    {/*   </Box> */}
                    {/* )} */}

                    <Box className="flex flex-wrap mt-4 -mb-4 -mx-4 justify-center">
                      {event?.speakers?.map((s, index) => (
                        <Box
                          key={`${s.email}-${index}`}
                          className="p-4 flex-1 max-w-xs text-center cursor-pointer hover:animate-heartbeat min-w-[15rem]"
                          onClick={() => setSpeakerModalTarget(s)}
                        >
                          <Box
                            className="p-8 flex flex-col items-center rounded-lg border border-forumm-menu-border"
                            color="backgroundColourSecondary"
                          >
                            <ProfileImage
                              size="lg"
                              imageUrl={s?.profileImage}
                            />
                            <Box
                              className="mt-8 font-bold text-lg"
                              style={{ minHeight: '60px' }}
                            >
                              {s.name}
                            </Box>
                            <Box className="mt-2" style={{ minHeight: '40px' }}>
                              {s.position}
                            </Box>
                            <Box className="mt-2" style={{ minHeight: '40px' }}>
                              {s.organization}
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box
                show={!!event?.sponsors && event?.sponsors?.length > 0}
                className="mt-8 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full"
              >
                {/* Sponsors */}
                <Box
                  color="foregroundColour"
                  className="rounded-2xl flex flex-col p-8 border border-forumm-menu-border flex-2 max-w-[100%] overflow-y-scroll scrollbar-hide"
                >
                  <Box className="text-2xl font-medium">Partners</Box>
                  {event?.sponsors && event?.sponsors.length > 0 && (
                    <Box className="text-xl">
                      <Box className="flex space-x-2 justify-evenly pb-10">
                        <Carousel
                          className={
                            'inline-block w-full justify-center items-center'
                          }
                          items={event.sponsors.map((s) => {
                            return {
                              url:
                                s.logoUrl ??
                                'https://assets.tumblr.com/images/default_header/optica_pattern_11.png',
                              title: s.title ?? '',
                              description: s.description ?? '',
                              onClick: () => {
                                if (s.websiteUrl) {
                                  window.open(s.websiteUrl, '_blank')
                                }
                              },
                            }
                          })}
                          fixedHeight={true}
                        />
                        {/* {event?.sponsors?.map((s, i) => { */}
                        {/*   return ( */}
                        {/*     <Card */}
                        {/*       className={`hidden sm:inline-block`} */}
                        {/*       key={i} */}
                        {/*       fixedWidth={true} */}
                        {/*       imgSrc={s.logoUrl ?? undefined} */}
                        {/*       onClick={() => { */}
                        {/*         if (s.websiteUrl && isValidUrl(s.websiteUrl)) */}
                        {/*           window.open( */}
                        {/*             fixUrlProtocol(s.websiteUrl), */}
                        {/*             '_blank' */}
                        {/*           ) */}
                        {/*         if (hasTicket || isAdmin) */}
                        {/*           router.push( */}
                        {/*             `/event/${event.eventId}/sponsors/${s.title}` */}
                        {/*           ) */}
                        {/*       }} */}
                        {/*     > */}
                        {/*       {s.title} */}
                        {/*     </Card> */}
                        {/*   ) */}
                        {/* })} */}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
              {canViewOrganizerInfo &&
                eventAttendees &&
                eventAttendees.length > 0 && (
                  <Box className="mt-8 flex flex-col md:flex-row space-y-6 md:space-x-6 md:space-y-0 w-full">
                    <Box
                      color="foregroundColour"
                      className="rounded-2xl flex flex-col p-2 md:p-8 border border-forumm-menu-border flex-2"
                    >
                      <Box className="text-2xl font-medium">Attendees</Box>
                      <Box className="mt-8 text-justify text-sm">
                        {event && (
                          <AttendeeList
                            event={event}
                            eventId={event.eventId!}
                            refetchEvent={refetch}
                            totalIncludingHidden={eventAttendees.length}
                            hiddenAttendees={
                              eventAttendees.length -
                              publiclyVisibleAttendes.length
                            }
                          />
                        )}
                      </Box>
                    </Box>
                  </Box>
                )}
              <GoogleAds
                show={getOrganisationConfig(
                  CONFIG_OPTIONS.SHOW_GOOGLE_ADS,
                  event.event?.organizationName ??
                    profile?.company ??
                    profile?.university
                )}
                type="horizontal"
                className="mt-8"
              />
            </Box>
          </Box>
        </Box>
        <Toaster
          toastOptions={{
            className:
              'shadow-lg !rounded-full flex items-center border-2 !bg-forumm-white border-forumm-green !text-forumm-green mt-[80px]',
            duration: 4000,
          }}
        />

        <FooterUnauthenticated transparent={false} />
      </Box>
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  try {
    const eventIdQuery = context.params?.eventId as string

    const eventId = (() => {
      if (eventIdQuery) {
        const decodedEventId = decodeURIComponent(eventIdQuery)
          .trim()
          .toLowerCase()

        if (eventIdsMap[eventIdQuery]) return eventIdsMap[eventIdQuery]
        if (eventIdsMap[decodedEventId]) return eventIdsMap[decodedEventId]
      }
      return eventIdQuery
    })()

    try {
      const apiUrl = process.env.NEXT_PUBLIC_API_URL
      if (!apiUrl) throw new Error('No API URL set!')
      const event: Partial<Event> = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: `
        query GetEventMetadata($eventId: String!) {
          getEventMetadata(eventId: $eventId) {
            eventId
            event {
              title
              shortDescription
              bannerImage
            }
          }
        }
      `,
          variables: {
            eventId,
          },
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          console.log(res)
          return res
        })
        .then((res) => {
          if (res.data.getEventMetadata) return res.data.getEventMetadata
        })
      const domain = process.env.NEXT_PUBLIC_DOMAIN as string
      const pageUrl = `https://${domain.includes('qa') || domain.includes('app') ? '' : 'app.'}${domain}/event/${event.eventId}`

      const payload: EventMetadata = {
        title: event?.event?.title ?? 'Forumm',
        description:
          event?.event?.shortDescription ??
          'Event management and fundraising made simple.',
        image:
          event?.event?.bannerImage ??
          'https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/f97ae674-f3d9-497e-bad7-db680ac3e832.png',
        url: pageUrl,
      }

      return {
        props: {
          eventId,
          metadata: payload,
        },
      }
    } catch (err) {
      console.log({ err })

      return {
        props: {
          eventId,
        },
      }
    }
  } catch (err) {
    console.log({ err })

    return {
      props: {},
    }
  }
}

EventPage.Layout = UnauthenticatedWrapperNoDefaults
